import {DocumentFileUploadResponse, DocumentsListResponseModel, SaleOrderRequest } from '@gtpl/shared-models/logistics';
import { Body, Controller, Post, UploadedFile, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { DocumentsListService } from './documents-list.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiConsumes, ApiTags } from '@nestjs/swagger';
import { DocumentsListRequest } from './dto/document-list.request';
import { FileInterceptor, FilesInterceptor } from '@nestjs/platform-express'
import { diskStorage } from 'multer';
import { extname } from 'path';
import { DocumentUploadDto } from './dto/document-upload-dto';
@Controller('documents-list')
@ApiTags('Document List ')
export class DocumentsListController {
    constructor(private service:DocumentsListService, private readonly applicationExceptionHandler: ApplicationExceptionHandler){}


  @Post('/DocumentFileUpload')
  @UseInterceptors(FilesInterceptor('file', null, {
    storage: diskStorage({
      destination: 'upload-files/post-sailing-upload-files',
      // destination: 'dist/apps/services/logistics/upload-files/post-sailing-upload-files',
      filename: (req, file, callback) => {
        // console.log(file);
        const name = file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
          .fill(null)
          .map(() => Math.round(Math.random() * 16).toString(16))
          .join('');
        callback(null, `${name}${fileExtName}`);
      },
    }),
    fileFilter: (req, file, callback) => {
      if (!file.originalname.match(/\.(xls|pdf|jpg|png|jpeg|doc|xlsx|csv)$/)) {
        return callback(new Error('Only xls,pdf, jpg, png, doc, jpeg files are allowed!'), false);
      }
      callback(null, true);
    },
  }))
  async DocumentFileUpload(@UploadedFiles() file, @Body() uploadData: DocumentUploadDto): Promise<DocumentFileUploadResponse> {
    try {
      console.log("uploadData");
      console.log(uploadData);

      return await this.service.updatePath(file,'upload-files/post-sailing-upload-files/',uploadData.saleOrderId,uploadData.documentCategory, uploadData.documentsListId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(DocumentFileUploadResponse, error);
    }
  }
  @Post('/createDocumentsList')
    async createDocumentsList(@Body() createDto:DocumentsListRequest): Promise<DocumentsListResponseModel>{
      console.log(createDto);
        try {
            return await this.service.createDocumentsList(createDto, false);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(DocumentsListResponseModel, error);
          }
    }

    @Post('getDocumentsList')
    async getDocumentsList(@Body() saleOrderRequest:SaleOrderRequest): Promise<DocumentsListResponseModel>{
        try {
            return await this.service.getDocumentsList(saleOrderRequest);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(DocumentsListResponseModel, error);
          }
    }
    @Post('getDocumentsDetailsBySoId')
    async getDocumentsDetailsBySoId(@Body() saleOrderRequest:SaleOrderRequest): Promise<DocumentsListResponseModel>{
        try {
            return await this.service.getDocumentsDetailsBySoId(saleOrderRequest);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(DocumentsListResponseModel, error);
          }
    }
    @Post('getDocumentsDetailsForSoId')
    async getDocumentsDetailsForSoId(@Body() saleOrderRequest:SaleOrderRequest): Promise<DocumentsListResponseModel>{
        try {
            return await this.service.getDocumentsDetailsForSoId(saleOrderRequest);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(DocumentsListResponseModel, error);
          }
    }
}
